import { useMount } from 'react-use';
import { DOM } from '@app/utils';
import { setUserCurrency } from '@app/redux/currency/actions';
import { useDispatch } from 'react-redux';

/**
 * Sets a user currency from social signups. Selected based off
 * a one time cookie that is set on the /social-confirm page
 */
const useHandleSocialCurrency = () => {
  const dispatch = useDispatch();

  useMount(() => {
    if (DOM.getCookie('social_redirect_currency')) {
      dispatch(
        setUserCurrency({
          currency: DOM.getCookie('social_redirect_currency'),
          locale: DOM.getCookie('stockx_selected_locale') || 'US',
        }),
      );

      DOM.delCookie('social_redirect_currency');
    }
  });
};

export default useHandleSocialCurrency;
